import React, { useEffect, useRef, useState } from 'react'
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import { Box, Grid, MenuItem, Paper, Tab, Tabs } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FilterComponent, PageLoader, PopOverCTA, STableLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CashFlowListing from '../components/CashFlowListing';
import CashflowDetailsModal from '../components/CashflowDetailsModal';
import LeaseReceivableCashflow from '../components/LeaseReceivableCashflow';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ButtonLoader } from '../../../shared_elements/components';
import { RoleBaseAccess } from '../../../hoc';
import { trackActivity } from '../../../utils/mixpanel';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { montYearFormat } from '../../../constants';
import { getCurrencyAc, getLesseeAc, getLessorAc } from '../../../shared_elements/actionCreators';
import { getAssetListApi } from '../../leases/apiServices';
import { getCashflowCategoriesApi, getTransactionTypesApi } from '../../settings/cashflow_categories/apiService';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { exportCashFlowApi } from '../apiService';
import ExportFileTypeComp from '../../../shared_elements/components/ExportFileTypeComp';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment';

const Cashflow = () => {
	const dispatch = useDispatch();
	const [tabIndex, setTabIndex] = useState(0);
	const [isLoading, setLoading] = useState(false)
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const [cashflowDetailsModal, setCashflowDetailsModal] = useState({
		open: false,
		start_date: null,
		end_date: null,
		mode: "monthly",
	});
	const [cashFlowListing, setCashFlowListing] = useState({})
	const [mode, setMode] = useState("monthly");
	const [currency, setcurrency] = useState("USD");
	const { lessee, lessor, currencies } = useSelector((state) => state.leases);
	const [year, setYear] = useState(new Date().getFullYear());
	const { leaseSlug } = useParams();
	const [isExport, setExport] = useState(false)
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [filter, setFilter] = useState({});
	const filterRef = useRef(filter);
	const [assetList, setAssetList] = useState([]);
	const [transactionTypes, setTransactionTypes] = useState([]);
	const [section, setSection] = useState([]);
	const statusLabel = [{ id: "draft", Label: "Draft" }, { id: "active", Label: "Active" }, { id: "closed", Label: "Closed" }, { id: "terminated", Label: "Terminated" }, { id: "on-hold", Label: "On-hold" }]
	const invoiceTypeOptions = [ { label: 'Maintenance Reserve', value: 1 }, { label: 'Rental', value: 2 }, { label: 'Penalty', value: 3 }, { label: 'Debit', value: 4 }, { label: 'Credit', value: 5 }, { label: 'Adhoc', value: 9 }, ];
	const showOnlyOption = [{value:'all',label:'All Section'},{value:'outflows',label:'Outflows Only'},{value:'inflows',label:'Inflows Only'}]
	const currencyOptions = currencies?.length > 0 ? currencies : [ { id: 27, code: 'GBP' }, { id: 3,  code: 'EURO' }, { id: 1,  code: 'USD' }, ];
	const currencyLabel = currency || "USD";
	const currencySymbol = currencyOptions.find( (cur) => String(cur.code) === String(currency) )?.symbol || "$";
	useEffect(() => {
		trackActivity('Page Viewed',{ page_title: 'CashFlow'})
	}, [])

	useEffect(() => {
		filterRef.current = filter;
	}, [filter])

	useEffect(() => {
		if (!leaseBasicDetails) return;
		if (leaseBasicDetails?.slug !== leaseSlug) return;
		if (leaseBasicDetails?.status === "Draft") return;
		if (year > maxAllowedYear) {
			setYear(maxAllowedYear);
			return;
		}
		if (year < minAllowedYear) {
			setYear(minAllowedYear);
			return;
		}
		getCashFlowList('skeletonLoader', mode, year, currency, filterRef.current)

		if (!lessee?.length) {
          dispatch(getLesseeAc({}));
        }

        if (!lessor?.length) {
          dispatch(getLessorAc({}));
        }

		if (!currencies?.length) {
          dispatch(getCurrencyAc({}));
        }

		getAssetList();
		getTransactionTypes();
		getSections();
	}, [leaseBasicDetails?.slug, leaseBasicDetails?.status, leaseBasicDetails?.start_date, leaseBasicDetails?.end_date, mode, year, currency, leaseSlug])

	const getCashFlowList = (loaderType, selectedMode, selectedYear, selectedCurrency, query={}) => {
		const queryString = new URLSearchParams(query).toString();
		const hasDateRange = query?.start_date && query?.end_date;
		const validYear = Math.min(Math.max(Number(selectedYear), minAllowedYear), maxAllowedYear);
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        const url = `/cashflows?${hasDateRange ? '' : `year=${validYear}&`}lease_slug=${leaseSlug}&mode=${selectedMode}&currency=${selectedCurrency}${queryString ? '&' + queryString : ''}`;
		globalGetService(url)
			.then(response => {
				if (checkApiStatus) {
					setCashFlowListing(response?.data)
					setFilter(query);
					loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
					if(response.data.statusCode === 400){
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
			})
	}
	const getAssetList = () => {
		globalGetService(getAssetListApi({})).then(response => {
			if (checkApiStatus) {
				setAssetList(response?.data?.data)
			}
		})
	}

	const getTransactionTypes = (query) => {
		globalGetService(getTransactionTypesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setTransactionTypes(response?.data?.data?.list);
				}
			})
	}

	const getSections = (query) => {
		globalGetService(getCashflowCategoriesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setSection(response?.data?.data?.list);
				}
			})
	}

	const handleModeChange = (newMode) => {
		setMode(newMode.toLowerCase())
	}

    const handleCurrencyChange = (newMode) => {
		setcurrency(newMode)
	}

	const today = new Date()
	const endDate = leaseBasicDetails?.end_date ? new Date(leaseBasicDetails.end_date) : null

	const maxAllowedYear = endDate ? endDate.getFullYear() : today.getFullYear();

	const minAllowedYear = leaseBasicDetails?.start_date
		? new Date(leaseBasicDetails.start_date).getFullYear()
		: 1900

	const handleYearSelect = (date) => {
		const selectedYear = moment(date).year();
		if (!selectedYear || selectedYear < minAllowedYear || selectedYear > maxAllowedYear) return;
		setYear(selectedYear);
		handleItemClicked('Selected Year');
	}

	const handleItemClicked = (page_type) => {
			trackActivity('Item Clicked', { page_title: 'CashFlow', page_type: page_type, })
		}
    const cashflowFilterMenu = {
		start_date: { title: 'From Date', inputType: 'date' },
        end_date: { title: 'To Date', inputType: 'date' },
		// lessor_ids: { title: 'Lessor', inputType: 'dropdown', options: lessor, valueKey: 'id', labelKey: 'name', multiple: true  },
		// lessee_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		// operator_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		// asset: { title: 'Asset', inputType: 'dropdown', options: assetList, valueKey: 'id', labelKey: 'name', multiple: true },
		// lease_status: { title: 'Lease Status', inputType: 'dropdown', options: statusLabel, valueKey: 'id', labelKey: 'Label', multiple: true },
		transaction_types: { title: 'Transaction Type', inputType: 'dropdown', options: transactionTypes, valueKey: 'id', labelKey: 'name' },
		show_only: { title: 'Show Only', inputType: 'dropdown', options: showOnlyOption, valueKey: 'value', labelKey: 'label', multiple: false },
		sections: { title: 'Cashflow Categories', inputType: 'dropdown', options: section, valueKey: 'name', labelKey: 'name' },
		hide_no_activity: { title: 'Hide rows with no activity', inputType: 'checkbox', value: true },
		hide_empty_sections: { title: 'Hide Empty Sections', inputType: 'checkbox', value: true },
	};

	const onApplyFilter = (query) => {
		
		if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
			enqueueSnackbar('From Date must be before To Date', { variant: 'error' });
			return false;
		}
		  const fromDate = query?.start_date && moment(query?.start_date).format('YYYY')  
		  const toDate= query?.end_date && moment(query?.end_date).format('YYYY')
		  const selectedYear = query.year || (fromDate ? fromDate : toDate || year);
		if (query.year) {
			setYear(query.year);
		}
		getCashFlowList("", mode, selectedYear, currency, query);
	};

	const handleExport = (fileType) => {
		const fromDate = filter?.start_date && moment(filter?.start_date).format('YYYY')
		const toDate = filter?.end_date && moment(filter?.end_date).format('YYYY')
		const selectedYear = (fromDate ? fromDate : toDate || year);

		let query = { ...filter, file_type: fileType, year: selectedYear, scope: 'contract', lease_slug: leaseSlug, currency: currency, mode: mode }

		setExport(true);
		globalGetService(exportCashFlowApi(query)).then((response) => {
			if (checkApiStatus(response)) {
				enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			setExport(false);
		})
	}
	const isDraft = leaseBasicDetails?.status === "Draft";
	const isLeaseNotFound = leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status;
    const minDateForFilter = leaseBasicDetails?.start_date 
	const maxDateForFilter = leaseBasicDetails?.end_date
	return (
		<>
			<LeasesBasicDetails />
			<Paper className='lease-details-section lease-nav-module-margin' elevation={0} sx={{boxShadow: "0px 0px 2px 1px #BBBBBB"}} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
				<LeasesNav />
				<Tabs value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)} style={{ margin: '10px 10px 0px 190px',flexShrink: 0,boxShadow: "0px 0px 2px 0.5px #BBBBBB"  }}>
					<Tab label="Cashflow" />
					<Tab label="Receivable" />
				</Tabs>
				<Box sx={{ flex: 1, minHeight: 0 }}>
				{isDraft ? (<ModuleNotExcessModal moduleName="Cashflow Statement" />) : isLeaseNotFound ? (<ModuleNotExcessModal leaseNotFound />) : tabIndex === 1 ? (
					<LeaseReceivableCashflow />
				) : (
				<div className='lease-details-content' style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
					<Paper className="responsive-paper" style={{ flexShrink: 0 }}>
						<Grid container spacing={1} className="responsive-grid" alignItems="end">
							<Grid item size={{ md: 12, xs: 12 }} sx={{ marginBottom:"-8px",}} className='lease-list-link-mt'>
									<BackToLeaseList />
							</Grid>
							<Grid size={'grow'} item xs={12} sx={{ minWidth: 0 }}>
									<div>
										<FilterComponent filter={filter} filterMenu={cashflowFilterMenu} getResponseBack={(query) => onApplyFilter(query)} minDate={minDateForFilter} maxDate={maxDateForFilter} />
									</div>
							</Grid>
							<Grid item md={5} xs={12}>
								<ul className='list-inline lease-details-btn' style={{ padding: 0 }}>
								  {!(filter?.start_date || filter?.end_date ) ?
									<li className="list-inline-item lease-mobile-button" style={{marginInline:'4px',verticalAlign:"middle"}}>
										<LocalizationProvider dateAdapter={AdapterMoment}>
											<DatePicker
												views={['year']}
												openTo="year"
												value={moment().year(year)}
												minDate={moment().year(minAllowedYear).startOf('year')}
												maxDate={moment().year(maxAllowedYear).endOf('year')}
												format="YYYY"
												onChange={handleYearSelect}
												slotProps={{
													textField: {
														size: 'small',
														variant: 'outlined',
														helperText: '',
														sx: {
															width: '85px',
															'& .MuiOutlinedInput-root': {
																height: '30px',
																borderRadius: '4px',
																backgroundColor: '#fff',
																'& fieldset': { borderColor: '#b6bbe8' },
																'&:hover fieldset': { borderColor: 'primary.main' },
																'&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1px' },
															},
															'& .MuiOutlinedInput-input': {
																padding: '0 0 0 8px',
																fontSize: '14px',
																fontWeight: 500,
																color: 'primary.main',
																cursor: 'pointer',
															},
															'& .MuiIconButton-root': {
																color: 'primary.main',
																padding: '2px',
																marginRight: '2px',
															},
															'& .MuiSvgIcon-root': { fontSize: '14px' },
														},
													},
												}}
											/>
										</LocalizationProvider>
									</li>:null}
									{<li className="list-inline-item lease-mobile-button" style={{marginInline:'4px'}}>
										<PopOverCTA btnText={currencyLabel} onCloseItem={true} Height="450px">
											<>
												{currencyOptions.map((currency) => (
													<MenuItem key={currency.id} sx={{background: currencyLabel === currency.code ? '#d6d4d4' : 'inherit',fontSize:'13px' }} onClick={() => { handleCurrencyChange(currency.code); handleItemClicked(`Clicked on ${currency.code}`); }} >{currency.code}</MenuItem>
												))}
											</>
										</PopOverCTA>
									</li>}
									{cashFlowListing?.mode ? <li className="list-inline-item lease-mobile-button">
										<PopOverCTA btnText={cashFlowListing?.mode}  onCloseItem={true}>
											<>
												<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'MONTHLY' ? '#d6d4d4' : 'inherit',fontSize:'13px'  }} onClick={() => { handleModeChange('MONTHLY'); handleItemClicked('Clicked on Monthly')}}>MONTHLY</MenuItem>
												<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'QUARTERLY' ? '#d6d4d4' : 'inherit',fontSize:'13px'  }} onClick={() => { handleModeChange('QUARTERLY'); handleItemClicked('Clicked on Quarterly')}}>QUARTERLY</MenuItem>
												<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'YEARLY' ? '#d6d4d4' : 'inherit',fontSize:'13px'  }} onClick={() => { handleModeChange('YEARLY'); handleItemClicked('Clicked on Yearly')}}>YEARLY</MenuItem>
											</>
										</PopOverCTA>
									</li> : null }
									{cashFlowListing?.data?.length ? <li className='lease-mobile-button' style={{marginInline:'4px'}}><ExportFileTypeComp handelExport={handleExport} isLoading={isExport}/></li> : null }
								</ul>
							</Grid>
						</Grid>
					</Paper>
					<Paper className='lease-detail-table' style={{ marginTop: '0px', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }} elevation={2} square>
						 {(skeletonLoader || leaseBasicDetails?.slug !== leaseSlug) ? <STableLoader count={6} rowCount={10} /> :
						<div className='cashflow-container' style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
							<CashFlowListing cashFlowListing={cashFlowListing} selectedCurrency={currencyLabel} currencySymbol={currencySymbol} onOpenDetails={(payload) => setCashflowDetailsModal({ open: true, ...payload })} handleItemClicked={handleItemClicked} />
						</div> }
						{isLoading ? <PageLoader /> : null}
					</Paper>
				</div>
				)}
				</Box>
			</Paper>
            {cashflowDetailsModal.open && (
                <CashflowDetailsModal open={cashflowDetailsModal.open} onClose={() => setCashflowDetailsModal({ open: false, start_date: null, end_date: null, mode: "monthly" })} start_date={cashflowDetailsModal.start_date} end_date={cashflowDetailsModal.end_date} mode={cashflowDetailsModal.mode} leaseSlug={leaseSlug} currency={currencyLabel} handleItemClicked={handleItemClicked} />
            )}
		</>
	)
}

export default RoleBaseAccess(Cashflow, { application: 'lease_revamp', feature: 'cashflow', operationType: ['R'] });